/* angular:styles/component:css;95d0fec72d33ba2b6614df80264c8bc3bac06ad1756066065a6511f21d12b166;/app/src/app/shared/components/round-button.ts */
.round-button {
  box-shadow: 0 1px 3px 0 rgba(140, 140, 140, 0.3);
  width: fit-content;
  padding: 10px 16px 10px 16px;
  border-radius: 18.5px;
  justify-content: center;
  display: flex;
  cursor: pointer;
  min-width: 125px;
  padding-left: 16px;
}
.round-button-image {
  margin-right: 8px;
}
/*# sourceMappingURL=round-button.css.map */
